export default __webpack_public_path__ + "static/media/question.35fb1b7c.png";